import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGInfo from 'visitor-ui-component-library-icons/icons/SVGInfo';
import { MEDIUM } from 'visitor-ui-component-library/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerWrapper = styled.div.withConfig({
  displayName: "SpotlightClosedConversationBanner__BannerWrapper"
})(["display:flex;align-items:center;gap:", ";padding:", " ", ";background:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";color:", ";font-size:", ";line-height:", ";"], ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.spacing.md, ({
  theme
}) => theme.spotlight.spacing.lg, ({
  theme
}) => theme.spotlight.color.bg, ({
  theme
}) => theme.spotlight.color.border, ({
  theme
}) => theme.spotlight.color.border, ({
  theme
}) => theme.spotlight.color.muted, ({
  theme
}) => theme.spotlight.typography.fontSize.xl, ({
  theme
}) => theme.spotlight.typography.lineHeight.md);
const IconWrapper = styled.span.withConfig({
  displayName: "SpotlightClosedConversationBanner__IconWrapper"
})(["flex:0 0 auto;display:flex;color:", ";"], ({
  theme
}) => theme.spotlight.color.muted);
const Title = styled.span.withConfig({
  displayName: "SpotlightClosedConversationBanner__Title"
})(["font-weight:", ";color:", ";"], ({
  theme
}) => theme.spotlight.typography.fontWeight.semibold, ({
  theme
}) => theme.spotlight.color.ink);
export default function SpotlightClosedConversationBanner({
  hasThreadHistoryMenu
}) {
  return /*#__PURE__*/_jsxs(BannerWrapper, {
    role: "status",
    "data-test-id": "spotlight-closed-conversation-banner",
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGInfo, {}),
        size: MEDIUM
      })
    }), /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-experience-components.closedConversationBanner.title"
        })
      }), hasThreadHistoryMenu && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-experience-components.closedConversationBanner.bodyWithMenu"
        })]
      })]
    })]
  });
}
SpotlightClosedConversationBanner.displayName = 'SpotlightClosedConversationBanner';